import React from "react";
import * as Icons from "lucide-react";
import { Reveal, Overline } from "../components/site/Reveal";
import { TechLines } from "../components/site/TechLines";
import { CONSULTANCY } from "../data/content";

const ICONS = ["Network", "HeartPulse", "Factory", "Cpu", "Truck", "Sparkles"];

export const Consultancy = () => (
  <section id="consultancy" className="relative overflow-hidden bg-charcoal py-24 text-off-white sm:py-32" data-testid="consultancy-section">
    <TechLines className="opacity-40" />
    <div className="grain absolute inset-0" />
    <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="max-w-3xl">
        <Reveal><Overline dark>Expert Consultancy</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-serif text-4xl font-light leading-tight sm:text-5xl">
            <span className="text-gradient-gold">{CONSULTANCY.partner}</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-off-white/70 sm:text-lg">{CONSULTANCY.intro}</p>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {CONSULTANCY.engagements.map((e, i) => {
          const Icon = Icons[ICONS[i % ICONS.length]] || Icons.Sparkles;
          return (
            <Reveal key={e.title} delay={(i % 3) * 0.08}>
              <div data-testid={`engagement-${i}`}
                className="glass h-full rounded-2xl p-7 transition-transform duration-500 hover:-translate-y-1.5">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-base/60 text-gold-light">
                  <Icon size={22} />
                </div>
                <h3 className="mt-5 font-serif text-xl">{e.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-off-white/65">{e.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
